import React from 'react';
import {
  Card,
  CardBody,
  Tooltip,
  Spinner,
  Chip,
  Button,
  CardFooter
} from "@heroui/react";
import dynamic from 'next/dynamic';
import { MapIcon } from '@heroicons/react/outline';
import { parseCoordinatesAndFindLocation } from '@/utils/findNearestPolishLocation';

// Dynamically import the map component to avoid SSR issues
const BookLocationMap = dynamic(() => import('@/components/Pages/Bookle/BookLocationMap'), {
  ssr: false,
  loading: () => (
    <div className="flex h-full w-full items-center justify-center bg-gray-100">
      <Spinner size="lg" />
    </div>
  )
});

interface MapLocationCardProps {
  title?: string;
  coordinates: [number, number] | number[];
  height?: number | string;
  tooltipText?: string;
  className?: string;
}

/**
 * MapLocationCard - A reusable component for displaying a location on a map
 */
export default function MapLocationCard({
  title = "Lokalizacja książki",
  coordinates,
  height = 300,
  tooltipText = "Największe najbliższe miasto",
  className = ""
}: MapLocationCardProps) {


  return (
    <Card className={`shadow-sm border border-gray-200 ${className}`}>

        <div className="flex flex-row justify-around items-center p-3">
          <div className='mr-auto'>
            <h3 className="text-lg font-medium text-gray-900">{title}</h3>
          </div>
            <Tooltip content={tooltipText}>
              <Chip
                  color="primary" startContent={<MapIcon className="h-4 w-4" />} variant="faded"
              >
                {parseCoordinatesAndFindLocation(coordinates, 'city')}
              </Chip>
            </Tooltip>
        </div>
      <CardBody className="p-0 overflow-hidden">

        <div style={{ height: height }} className="w-full rounded-b-xl overflow-hidden">
          <BookLocationMap marker={coordinates} />
        </div>
      </CardBody>
    </Card>
  );
}